var _rect, _path, _rect2, _rect3, _rect4, _circle, _mask, _g, _circle2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgProfileCheckImage = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 88,
  height: 107,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 81.597,
  height: 100.842,
  y: 6.158,
  fill: "#FFE040",
  rx: 4
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F3A900",
  d: "M0 10.158a4 4 0 0 1 4-4h73.597a4 4 0 0 1 4 4v2.928H0z"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 53.115,
  height: 4.619,
  x: 14.625,
  y: 74.669,
  fill: "#656565",
  rx: 2.309
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 53.115,
  height: 4.619,
  x: 14.625,
  y: 62.353,
  fill: "#656565",
  rx: 2.309
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  width: 53.115,
  height: 4.619,
  x: 14.625,
  y: 86.985,
  fill: "#656565",
  rx: 2.309
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 40.799,
  cy: 36.95,
  r: 15.396,
  fill: "#fff"
})), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  id: "profileCheckImage_svg__a",
  width: 32,
  height: 32,
  x: 25,
  y: 21,
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 40.799,
  cy: 36.95,
  r: 15.396,
  fill: "#fff"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#profileCheckImage_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M40.767 51.593a1.614 1.614 0 1 0-.516-3.187 1.614 1.614 0 0 0 .516 3.187"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#7E4F4D",
  d: "m49.239 47.44-4.99-2.3a1.34 1.34 0 0 1-.773-1.214v-3.359H37.36v3.36c0 .526-.307.995-.774 1.214l-4.99 2.298a4.02 4.02 0 0 0-2.32 3.893l.443 7.366c.04.704.628 1.255 1.33 1.255h18.747c.701 0 1.29-.55 1.33-1.255l.443-7.366a4.02 4.02 0 0 0-2.329-3.893"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EB3737",
  d: "m49.24 47.438-3.796-1.748c-.491 2.34-2.563 4.104-5.037 4.104-2.475 0-4.546-1.757-5.038-4.096l-3.788 1.74a4.02 4.02 0 0 0-2.321 3.893l.443 7.366c.04.704.629 1.255 1.33 1.255h18.748c.7 0 1.29-.55 1.33-1.255l.443-7.366a3.985 3.985 0 0 0-2.314-3.893"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#543736",
  d: "M37.36 44.064a7.3 7.3 0 0 0 3.062.672c1.088 0 2.12-.243 3.063-.672v-1.78h-6.118z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M44.085 27.38a3.686 3.686 0 0 0-3.36-3.982 3.68 3.68 0 0 0-3.966 3.373 3.686 3.686 0 0 0 3.36 3.983 3.68 3.68 0 0 0 3.966-3.374"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M40.416 39.823c4.055 0 7.342-3.164 7.342-7.066s-3.287-7.066-7.342-7.066-7.343 3.164-7.343 7.066 3.288 7.066 7.343 7.066"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#7E4F4D",
  d: "M47.395 34.934c-.048-.016-.355-.024-.355-.024-.322 0-.636-.13-.862-.356l-.532-.535c-.21-.21-.492-.34-.79-.356-1.193-.064-4.497-.364-7.117-1.659-.282-.137-.62-.065-.79.202-.685 1.085-1.54 1.935-2.015 2.38-.225.21-.523.324-.83.324h-.443a1 1 0 0 0-.202.024c-.596.113-.999.688-.999 1.295v.445c0 .591.379 1.142.943 1.28q.192.046.37.032a.597.597 0 0 1 .63.501c.523 2.866 3.014 5.035 6.012 5.035s5.489-2.17 6.013-5.035a.604.604 0 0 1 .629-.501c.12.008.241 0 .37-.033.572-.137.943-.688.943-1.279v-.558c.008-.583-.427-1.004-.975-1.182"
}))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 73.899,
  cy: 13.856,
  r: 13.856,
  fill: "#00B55E"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M72.866 19.561h-.008a3.08 3.08 0 0 1-2.475-1.266l-2.58-3.552a2.22 2.22 0 0 1 .485-3.095 2.207 2.207 0 0 1 3.087.487l1.496 2.06 4.375-5.958a2.206 2.206 0 0 1 3.089-.47 2.22 2.22 0 0 1 .47 3.097l-5.466 7.444a3.08 3.08 0 0 1-2.473 1.253"
})));
export default SvgProfileCheckImage;